import photoMiniDienAnh from '../../img/News/6-da-o-die-n-ti-do-lam-nen-thanh-cong-cua-nhu-ng-bom-ta-n-di-nh-da-m-nha-t-hollywood-15966023547553.png';
export const dataMiniDienAnh =[
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    }
]
export const dataMiniReview =[
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    }
]
export const dataMiniKhuyenMai =[
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    },
    {
        hinhAnh:photoMiniDienAnh,
        title:'6 đạo diễn tỉ đô làm nên thành công của những bom tấn đình đám nhất Hollywood'
    }
]